import api from "@/api";
export default class CMM {
  constructor(_default) {
    if (_default !== undefined) {
      this._default = _default;
      for (let prop in _default) {
        this[prop] = _default[prop];
      }
    }
  }

  static async fetch(cmm_id) {
    const res = await api.get(`/api/v1/repair/cmm/`, { id: cmm_id });
    if (res) return res.data;
    return null;
  }

  static async list(params) {
    const res = await api.get(`/api/v1/repair/cmm/`, params);
    if (res) return res.data;
    return null;
  }

  static async store(payload) {
    const res = await api.post(`/api/v1/repair/create/cmm/`, payload);
    if (res) return res.data.data;
    return null;
  }

  static async update(payload) {
    const res = await api.put(
      `/api/v1/repair/update/cmm/${payload.id}/`,
      payload
    );
    if (res) return res.data.data;
    return null;
  }
}
